<div class="row center-xs main-container">
    <div class="col-xs-12 col-sm-11 col-md-9">
        <div class="row start-xs">
            <div class="col-xs-12">
                <div id="operations-swagger-ui"></div>
            </div>
        </div>
    </div>
</div>